import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Sidebar from "../Sidebar";
import DashboardHeader from "../DashboardHeader";
import ConfirmModal from "../../Modal/ConfirmModal";
import { logout } from "../../store/authSlice";
import styles from "./DashboardLayout.module.css";

export default function DashboardLayout({ children, basePath = "admin" }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isDesktop, setIsDesktop] = useState(
    typeof window !== "undefined" ? window.innerWidth >= 1024 : true
  );
  const [sidebarOpen, setSidebarOpen] = useState(isDesktop);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const desktop = window.innerWidth >= 1024;
      setIsDesktop(desktop);
      setSidebarOpen(desktop);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const closeSidebar = () => {
    if (!isDesktop) setSidebarOpen(false);
  };

  const confirmLogout = () => {
    dispatch(logout());
    setShowLogoutModal(false);
    navigate("/", { replace: true });
  };

  return (
    <div className={styles.dashboardLayout}>
      {!isDesktop && sidebarOpen && (
        <div className={styles.overlay} onClick={closeSidebar} />
      )}

      <div className={styles.mainLayout}>
        <aside
          className={`${styles.sidebarContainer} ${
            sidebarOpen ? styles.sidebarVisible : styles.sidebarHidden
          } ${isDesktop ? styles.desktopSidebar : ""}`}
        >
          <Sidebar
            basePath={basePath}
            onLinkClick={closeSidebar}
            showCloseButton={!isDesktop}
            onCloseSidebar={closeSidebar}
            onLogout={() => setShowLogoutModal(true)}
          />
        </aside>

        <div className={styles.mainColumn}>
          <DashboardHeader
            basePath={basePath}
            onLogout={() => setShowLogoutModal(true)}
            onOpenSidebar={() => setSidebarOpen(true)}
            showMenu={!isDesktop}
          />
          <main className={styles.content}>{children}</main>
        </div>
      </div>

      <ConfirmModal
        show={showLogoutModal}
        title="Logout"
        message="Are you sure you want to logout?"
        onConfirm={confirmLogout}
        onCancel={() => setShowLogoutModal(false)}
      />
    </div>
  );
}
